module.exports = __webpack_public_path__ + "static/paczki@2x-2ef1b0b3aa62faec254f30fc7afb22b3.png";